export const Classique = {
  key: 'CLASSIQUE'
};

export const Atypique = {
  key: 'ATYPIQUE'
};

export const HoursTypes = {
  Classique,
  Atypique
};
